export default {
  areas: {
    hero: {
      eyebrow: "Zone d'intervention",
      title: 'Caméras de sécurité et alarmes dans toute la région Rhin-Main',
      subtitle: 'De Francfort en passant par Offenbach, Hanau et Darmstadt jusqu’à Groß-Gerau : SSG Signaltechnik planifie, installe et entretient vidéosurveillance et alarmes pour particuliers et professionnels, en personne et sur place.',
      ctaPrimary: 'Demander une première consultation gratuite',
      ctaSecondary: 'Découvrir la vidéosurveillance',
    },
    breadcrumbHome: 'Accueil',
    breadcrumbCurrent: "Zone d'intervention",
    intro: {
      eyebrow: 'Où nous intervenons pour vous',
      title: 'Des distances courtes dans toute la région',
      p1: 'Notre entreprise de sécurité est basée à Hainburg et se déplace rapidement dans toute la région Rhin-Main. Caméra, vidéosurveillance ou alarme : nous venons à vous, analysons votre bien et installons tout proprement et professionnellement.',
      p2: 'Maison, immeuble, local commercial, bureau, entrepôt ou atelier : nous gérons des projets de toutes tailles à Francfort, Offenbach, Hanau, Darmstadt, Groß-Gerau et communes alentour.',
    },
    city: 'Ville',
    district: 'Arrondissement',
    coverage: {
      eyebrow: 'Ancré localement',
      title: 'Votre spécialiste de la région, pour la région',
      p1: "En tant qu'entreprise locale de la région Rhin-Main, nous connaissons les exigences et conditions du terrain. Pour votre caméra ou alarme : distances courtes, contacts personnels et rendez-vous rapides.",
      p2: 'Nous nous déplaçons aussi au-delà de la région Rhin-Main sur accord. Contactez-nous et nous vérifierons ce qui est possible pour votre projet.',
      ctaPrimary: 'Demander maintenant',
      ctaSecondary: 'Découvrir les systèmes d’alarme',
      caption: 'Montage et configuration personnels sur place, depuis Hainburg dans toute la région Rhin-Main.',
    },
    cta: {
      title: 'Caméra de sécurité ou alarme pour votre bien ?',
      lead: 'Nous vous conseillons sans engagement et vous montrons la solution adaptée à votre bien et budget, dans toute la région Rhin-Main.',
      primary: 'Demander une première consultation gratuite',
      secondary: 'Lancer le planificateur de caméras',
    },
  },
};